import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'components/Button';
import PropTypes from 'prop-types';
import { useFetchFavorites } from 'containers/NewSearchPage/hooks/useFetchFavorites';
import {
  addToFavorites,
  deleteFromFavorites,
} from '../../../actions/favorite/favorite.actions';
import { CLEAR_FAVORITE_ERROR } from '../../../actions/favorite/constants';
import {
  selectVCardContent,
  selectVcardFavorite,
} from '../../../selectors/vcard.selector';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import HtmlParser from 'react-html-parser';
import { pushGTMEvent } from '../../../../Player/utils/analytics';
import deleteSymbols from '../../../../../utils/deleteSymbols';
import getContentAvailability from '../../../../../utils/getContentAvailability';
import getContentType from '../../../../../utils/getContentType';
import { getAnonymousQueryParams } from 'containers/Player/utils/getAnonymousQueryParams';
import { getRegion } from 'utils/Region';
import { createSearchParams, useNavigate } from 'react-router-dom';

const FavoriteButton = ({ groupId, userHasSession }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const asset = useSelector(state => state.asset);
  const translations = useSelector(state => state.translations);
  const favorites = useSelector(state => state.favorites);
  const isFavoritesApiLoading = useSelector(
    state => state.Vcard.favorite.loadingApi,
  );
  const favoriteResponse = useSelector(selectVcardFavorite);
  const content = useSelector(selectVCardContent);
  const isFavorite = favorites && favorites.find(fav => fav.id === groupId);
  const [favBtn, setFavBtn] = useState(!!isFavorite);
  const loadingFavoriteResp =
    favoriteResponse.add.isLoading || favoriteResponse.delete.isLoading;
  const { isMobile } = useVerifyIsMobile(768);


  useEffect(() => {
    setFavBtn(isFavorite)
  }, [isFavorite])

  useEffect(
    () => {
      dispatch({ type: CLEAR_FAVORITE_ERROR });
    },
    [groupId],
  );

  useEffect(
    () => {
      if (favoriteResponse.add.error || favoriteResponse.delete.error)
        setFavBtn(prevState => !prevState);
    },
    [favoriteResponse.add.error, favoriteResponse.delete.error],
  );

  const handleFavorite = () => {
    if (loadingFavoriteResp || isFavoritesApiLoading) return;
    const { queryParams } = getAnonymousQueryParams(content, true)

    if (!userHasSession) {
      return navigate(`/${getRegion()}/login?${createSearchParams(queryParams)}`, {
        state: queryParams,
        replace: true
      });

    }
    setFavBtn(prevState => !prevState);
    const params = {
      user_hash: userHasSession,
      object_id: groupId,
      object_type: 1,
    };
    const contentAvailability = getContentAvailability(
      content.types,
      content.proveedorCode,
    );
    const contentType = getContentType(content);
    const favoriteEventInfo = {
      event: 'interaction_content',
      content_section: 'vcard',
      item_id: content.group_id,
      content_name: content.title,
      content_type: contentType,
      content_category: deleteSymbols(
        content.genres
          .map(genre => genre.desc)
          .toString()
          .toLowerCase(),
      ),
      content_availability: contentAvailability.toString(),
    };
    if (!isFavorite) {
      pushGTMEvent({
        ...favoriteEventInfo,
        interaction_type: 'agregar a mi lista',
      });
      dispatch(addToFavorites(params));
      return;
    }
    pushGTMEvent({
      ...favoriteEventInfo,
      interaction_type: 'quitar de mi lista',
    });
    dispatch(deleteFromFavorites(params));
  };

  return (
    <Button buttonType="icon-button" onClick={handleFavorite}>
      <div className="ActionButton__content">
        <div className="ActionButton__content__image">
          <img
            src={
              (!favBtn && asset.vcard_access_option_icon_addList) ||
              asset.vcard_access_option_icon_deleteList
            }
            alt="play"
          />
        </div>
        <p className="ActionButton__content__text">
          {isMobile
            ? (!favBtn &&
              translations.vcard_access_option_button_addFavoritiesList_text2) ||
            translations.vcard_access_option_button_deleteFavoritiesList_text1
            : (!favBtn &&
              HtmlParser(
                translations.vcard_access_option_button_addFavoritiesList,
              )) ||
            HtmlParser(
              translations.vcard_access_option_button_deleteFavoritiesList,
            )}
        </p>
      </div>
    </Button>
  );
};

FavoriteButton.propTypes = {
  groupId: PropTypes.string,
  userHasSession: PropTypes.string,
};

export default FavoriteButton;
